import React from 'react'
import CardDetails from '../../components/cardDetails/CardDetails';

export default function Details() {
    return (
        <main>
            <CardDetails />
        </main>
    )
}
